import { Plane, Vector3 } from "three";

const simplepolygon = require('simplepolygon');

export const pointInPolygon = (point, vertices) => {
  let numberOfVertices = vertices.length;
  let insidePolygon = false;

  let j = numberOfVertices - 1;
  for (var i = 0; i < numberOfVertices; i++) {
    let verti = vertices[i];
    let vertj = vertices[j];

    let dx = vertj.x - verti.x;
    let dy1 = point.y - verti.y;
    let dy2 = vertj.y - verti.y;

    let cond1 = (verti.y > point.y) !== (vertj.y > point.y);
    let cond2 = point.x < (dx * dy1 / dy2 + verti.x);

    // currently checks [boundMin, boundMax)

    if (cond1 && cond2) {
      insidePolygon = !insidePolygon;
    }
    j = i;
  }
  return insidePolygon;
};

export const planeFromVectors = (directions) => {
  let normal = new Vector3();
  directions.forEach(vertex => {
    normal.add(vertex);
  });

  normal.divideScalar(directions.length);
  normal.setLength(1.0);

  return new Plane(normal);
};

export const checkValidPolygon = (coordinates) => {
  try {
    // Unshifted points give false positives sometimes
    let origin = coordinates[0];
    let shifted = coordinates.map(x => {
      return [x[0]-origin[0], x[1]-origin[1]];
    });

    let poly = {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [shifted]
      }
    };

    let result = simplepolygon(poly);
    return result.features.length === 1;
  } catch {
    return false;
  }
};
